module.exports = __webpack_public_path__ + "img/fukidashi-p01.db7fd00b.png";